import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';
import { signoutURL } from '../constants';

export const HeaderApis = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    userSignout: builder.mutation<
      {
        responseCode: number;
        status: string;
        message: string;
      },
      {
        emailId?: string;
        currentLicenseId?: string;
        refreshToken?: string;
        signOutType?: string;
      }
    >({
      query: payload => ({
        url: `${signoutURL}`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});
